import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams, currencyFormatter } from '../CustomUtils'
import { COST_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const COST_REPORT = gql(COST_REPORT_QUERY)

export default function CostReport({ location }) {
  console.log('CostReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, COST_REPORT, 'costReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Woodcosts/costReport/external_legal_cost.csv?inputs=${JSON.stringify(inputs)}`
    const numberFormatter = new Intl.NumberFormat()
    const totalColumns = [
      { columnNumber: 1, formatter:  numberFormatter.format },
      { columnNumber: 3 },
      { columnNumber: 4, formatter: currencyFormatter('GBP').format }
    ]
    const columnFormatters = [
      { columnNumber: 1, formatter: numberFormatter.format, align: 'right' },
      { columnNumber: 3, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 4, formatter: currencyFormatter('GBP').format, align: 'right' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', margin: 'auto'}} >
          <ReportHeading title='Wood External Legal Cost' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}